import React from "react";
import { useSelector } from "react-redux";
import LanguageTable from "./LanguageTable";
import LanguageDialogue from "./LanguageDialogue";
import UploadCSVDialogue from "./UploadCSVDialogue";
import TranslationInfoDialogue from "./TranslationInfoDialogue";

const Language = () => {
    const { dialogueType } = useSelector((state) => state.dialogue);

    return (
        <div className="userPage">
            <LanguageTable />
            {dialogueType === "language" && <LanguageDialogue />}
            {dialogueType === "uploadCSV" && <UploadCSVDialogue />}
            {dialogueType === "translationInfo" && <TranslationInfoDialogue />}
        </div>
    );
};

export default Language;
